/**
 * Helper function that will extract all props from an object and will return them.
 * The rest returned are the ones that don´t belong to the object.
 * @internal
 */
export function extract<T extends object, K extends keyof T>(
  obj: T,
  keys: Array<K>,
): { extracted: Pick<T, K>; rest: Omit<T, K> } {
  const extracted: Pick<T, K> = {} as Pick<T, K>;
  const rest: Omit<T, K> = { ...obj } as Omit<T, K>;
  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      extracted[key] = obj[key];
      // @ts-expect-error: Typesafety is not given for hasOwnProperty where it states that key could still be of type K
      delete rest[key];
    }
  }

  return { extracted, rest };
}
